import type { ReferralConfig, ReferralMemberState, ReferralStats } from '../../../model/referral/referral';

export interface GetReferralConfigRequest {
  country: string;
}
export type GetReferralConfigResponse = ReferralConfig;
export type GetReferralMemberRequest = GetReferralConfigRequest;
export type GetReferralMemberResponse = ReferralMemberState;
export type EnsureReferralMemberRequest = GetReferralConfigRequest;
export type EnsureReferralMemberResponse = ReferralMemberState;
export interface GetReferralStatsRequest {
  currency: string;
}
export type GetReferralStatsResponse = ReferralStats;
export interface RecordReferralArrivalRequest {
  referralCode: string;
  actorId: string;
}
export interface RecordReferralArrivalResponse {
  accepted: boolean;
  code: string | null;
  requestedCode?: string;
}
export interface SyncReferralIdentityRequest {
  actorId: string;
  targetActorId: string;
}
export interface SyncReferralIdentityResponse {
  actorId: string;
  synced: true;
}
export interface UpdateReferralCountryRequest {
  country: string;
}
